import { RoomExtra, RoomExtraOption } from 'shared-types/Room';
import { PerDate } from './PerDate';
import { PerDateTime } from './PerDateTime';
import { PerTimeRange } from './PerTimeRange';
import { PerDateRange } from './PerDateRange';
import { PerDateTimeRange } from './PerDateTimeRange';

export const controlTypes = (extra: RoomExtra) => {
  const id = extra.id as number;
  const options: RoomExtraOption[] = 'options' in extra ? extra.options : [];
  return (
    {
      per_date: <PerDate id={id} options={options} />,
      per_date_time: <PerDateTime id={id} options={options} />,
      per_time_range: <PerTimeRange id={id} options={options} />,
      per_date_range: <PerDateRange id={id} options={options} />,
      per_date_time_range: <PerDateTimeRange id={id} options={options} />,
    }[extra.type] || null
  );
};
